import { encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";
import { da } from "date-fns/locale";

class DriverGroupStore {
    driverGroupDrivers = [];
    loading = false;
    driverList = [];
    driverArray = [];
    rootStore;

    constructor(rootStore) {
        makeObservable(this, {
            driverGroupDrivers: observable,
            loading: observable,
            driverArray: observable,
            addData: action,
            getDriverGroupData: action,
            getAssetData: action,
            deleteRecord: action,
        });
        this.rootStore = rootStore;
    }


    async getDriveGroup({ companyId }) {
        this.loading = true;

        var postData = { companyId: companyId, userId: null };

        var response = await postApi
            .getClient("")
            // .get("http://localhost:3001" + "/driver/getDriverGroup", {
            .get(config.NodeUrl + "/driver/getDriverGroup", {
                params: postData,
            });
        this.loading = false;

        this.driverGroupDrivers =
            response?.data?.data;//?.DeviceGroupData[0]?.devicegroups;
        this.loading = false;
    }



    async addData(postData) {
        // const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
            .getClient("")
            .post(
                // "http://localhost:3001" + "/driver/updateDriverGroups",
                config.NodeUrl + "/driver/updateDriverGroups",
                postData
            );

        return response;
    }

    async getDriverGroupData(drgId, companyId) {
        var postData = {
            drgId: drgId,
            limit: 1,
            offset: 0,
            companyId: companyId,
        };
        var response = await postApi
            .getClient("")
            .get(
                config.NodeUrl + "/driver/getDriverGroup", {
                // "http://localhost:3001" + "/driver/getDriverGroup", {
                params: postData,
            });
        this.loading = false;
        this.driverArray =
            response.data.data;
        return response.data.data[0];
    }



    // To get asset list
    async getAssetData(companyId) {
        var postData = { companyId: companyId };
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
            .getClient()
            .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);

        this.driverList = response?.data?.data;
        return response?.data?.data;
    }


    async deleteRecord({ drgId }) {
        var response = await postApi
            .getClient("")
            .delete(config.NodeUrl + "/driver/deleteDriverGroup", {
                // .delete("http://localhost:3001" + "/driver/deleteDriverGroup", {
                params: {
                    drgId: drgId,
                },
            });
        return response;
    }
}

export default DriverGroupStore;
